if (!customElements.get('oreilly-product-swatches')) {
  let swatchInstance = 0;

  customElements.define('oreilly-product-swatches', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.initialize());
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.animation?.cancel();
      this.animation = null;
      if (this.overflow) this.overflow.hidden = !this.expanded;
    }

    initialize() {
      if (!this.isConnected) return;
      if (!this.button) {
        this.row = this.querySelector('.oreilly-product-swatches__row');
        this.preview = this.querySelector('[data-swatch-preview]');
        this.remaining = this.querySelector('[data-swatch-remaining]');
        this.overflow = this.querySelector('.oreilly-product-swatches__overflow');
        this.button = this.querySelector('button');
        this.more = this.querySelector('[data-swatch-more]');
        this.swatches = Array.from(this.querySelectorAll('.oreilly-product-swatches__swatch'));
        this.overflow.id = 'oreilly-swatch-overflow-' + (++swatchInstance);
        this.button.setAttribute('aria-controls', this.overflow.id);
        this.button.addEventListener('click', () => this.setExpanded(!this.expanded));
        this.observer = new ResizeObserver(([entry]) => {
          if (entry.contentRect.width === this.lastWidth) return;
          this.lastWidth = entry.contentRect.width;
          this.layout();
        });
        document.fonts.ready.then(() => {
          if (this.isConnected) this.layout();
        });
      }
      this.layout();
      this.observer.observe(this);
    }

    layout() {
      const width = this.clientWidth;
      if (!width || !this.swatches.length) return;
      const focused = this.contains(document.activeElement) ? document.activeElement : null;
      const size = this.swatches[0].getBoundingClientRect().width;
      const total = this.swatches.length;
      let count = Math.min(6, total);
      const showToggle = total > count || count * size > width;
      this.button.hidden = !showToggle;

      if (showToggle) {
        const gap = parseFloat(getComputedStyle(this.row).columnGap);
        // Reserve space for both labels so opening never moves the toggle.
        while (count > 1) {
          this.more.textContent = this.dataset.moreLabel.replace('[count]', total - count);
          if (count * size + gap + this.button.getBoundingClientRect().width <= width) break;
          count--;
        }
        this.more.textContent = this.dataset.moreLabel.replace('[count]', total - count);
      }

      if (count !== this.visibleCount) {
        this.visibleCount = count;
        this.preview.append(...this.swatches.slice(0, count));
        this.remaining.append(...this.swatches.slice(count));
        this.preview.querySelectorAll('a').forEach(link => link.removeAttribute('tabindex'));
        this.setExpanded(showToggle && Boolean(this.expanded), false);
        if (focused) {
          let target = !this.expanded && this.remaining.contains(focused) ? this.button : focused;
          if (target === this.button && this.button.hidden) target = this.swatches[count - 1];
          target.focus({ preventScroll: true });
        }
      }
    }

    setExpanded(expanded, animate = true) {
      const height = this.overflow.getBoundingClientRect().height;
      this.animation?.cancel();
      this.animation = null;
      this.expanded = expanded;
      this.button.setAttribute('aria-expanded', String(expanded));
      this.button.setAttribute('aria-label', expanded ? this.dataset.lessDescription : this.dataset.moreDescription.replace('[count]', this.swatches.length - this.visibleCount));
      this.overflow.setAttribute('aria-hidden', String(!expanded));
      this.overflow.toggleAttribute('inert', !expanded);
      this.remaining.querySelectorAll('a').forEach(link => {
        if (expanded) link.removeAttribute('tabindex');
        else link.setAttribute('tabindex', '-1');
      });

      if (!animate || matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.overflow.hidden = !expanded;
        return;
      }

      this.overflow.hidden = false;
      const style = getComputedStyle(this);
      const animation = this.overflow.animate(
        [{ height: height + 'px' }, { height: (expanded ? this.overflow.scrollHeight : 0) + 'px' }],
        { duration: parseFloat(style.getPropertyValue('--oreilly-motion-slow')), easing: style.getPropertyValue('--oreilly-ease-standard').trim() }
      );
      this.animation = animation;
      animation.onfinish = () => {
        this.overflow.hidden = !expanded;
        this.animation = null;
      };
    }
  });
}
